import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "*",
    redirect: "/home",
  },
  {
    path: "/urgent",
    component: () => import("../views/urgent/index.vue"),
    meta: {
      title: "紧急公告",
    },
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/home/home.vue"),
    meta: {
      title: "首页",
      type: "login", // 是否需要判断是否登录,这里是需要判断
    },
  },
  // {
  //   path: "/test",
  //   name: "test",
  //   component: () => import("../views/test/test.vue"),
  // },
  {
    path: "/liveMatches",
    name: "liveMatches",
    meta: {
      title: "直播",
      type: "login",
    },
    component: () => import("../views/liveMatches/index.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: () => import("../views/news/index.vue"),
  },
  {
    path: "/news_detail/:id",
    name: "news_detail",
    component: () => import("../views/news/news_detail.vue"),
  },
  {
    path: "/notice/:id",
    name: "notice",
    component: () => import("../views/notice/index.vue"),
  },
  {
    path: "/protocol/:id",
    name: "protocol",
    component: () => import("../views/protocol/index.vue"),
  },
  {
    path: "/activity",
    name: "activity",
    component: () => import("../views/activity/index.vue"),
  },
  {
    path: "/activity_details/:id",
    name: "activity_details",
    component: () => import("../views/activity/activity_details.vue"),
  },
  {
    path: "/game",
    name: "game",
    component: () => import("../views/game/index.vue"),
  },
  {
    path: "/gameDetail/:url",
    name: "gameDetail",
    component: () => import("../views/game/gameDetail.vue"),
  },
  {
    path: "/schedule",
    name: "schedule",
    component: () => import("../views/schedule/index.vue"),
  },
  {
    path: "/scheduleDetail/:id/:sportId",
    name: "scheduleDetail",
    component: () => import("../views/schedule/scheduleDetail.vue"),
  },
  {
    path: "/worldCup",
    name: "worldCup",
    component: () => import("../views/worldCup/index.vue"),
  },
  {
    path: "/download",
    name: "download",
    component: () => import("../views/download/index.vue"),
  },
  {
    path: "/about/:id",
    name: "about",
    component: () => import("../views/about/index.vue"),
  },
  {
    path: "/keysearch",
    name: "keysearch",
    component: () => import("../views/keysearch/index.vue"),
  },
  // {
  //   path: "/login",
  //   name: "login",
  //   component: () => import("../views/login/index.vue"),
  // },
  {
    path: "/liveMatchesTwo/:id",
    name: "liveMatchesTwo",
    meta: {
      title: "直播间",
      type: "login",
    },
    component: () => import("../views/liveMatchesTwo/index.vue"),
  },
  {
    path: "/user-center/index",
    name: "user-center",
    component: () => import("../views/user-center/index.vue"),
  },
  {
    path: "/user-center/apply-anchor",
    name: "apply-anchor",
    component: () => import("../views/user-center/apply-anchor.vue"),
  },
  {
    path: "/user-center/myWallet",
    name: "myWallet",
    component: () => import("../views/user-center/myWallet.vue"),
  },
  {
    path: "/user-center/center-anchor",
    name: "center-anchor",
    component: () => import("../views/user-center/center-anchor.vue"),
  },
  {
    path: "/user-center/live-room-settings",
    name: "live-room-settings",
    component: () => import("../views/user-center/live-room-settings.vue"),
  },
  {
    path: "/user-center/guessing-management",
    name: "guessing-management",
    component: () => import("../views/user-center/guessing-management.vue"),
  },
  {
    path: "/user-center/focus",
    name: "focus",
    component: () => import("../views/user-center/focus.vue"),
  },
  {
    path: "/user-center/mySchedule",
    name: "mySchedule",
    component: () => import("../views/user-center/mySchedule.vue"),
  },
  {
    path: "/user-center/watchHistory",
    name: "watchHistory",
    component: () => import("../views/user-center/watchHistory/index.vue"),
  },
  {
    path: "/user-center/betHistory",
    name: "betHistory",
    component: () => import("../views/user-center/betHistory/index.vue"),
  },
  {
    path: "/user-center/rechargeHistory",
    name: "rechargeHistory",
    component: () => import("../views/user-center/rechargeHistory/index.vue"),
  },
  {
    path: "/user-center/recharge",
    name: "recharge",
    component: () => import("../views/user-center/recharge/index.vue"),
  },
  {
    path: "/user-center/checkin",
    name: "checkin",
    component: () => import("../views/user-center/checkin/index.vue"),
  },
  {
    path: "/user-center/privateChat",
    name: "privateChat",
    component: () => import("../views/user-center/privateChat/index.vue"),
  },
  {
    path: "/help",
    name: "help",
    component: () => import("../views/help/index.vue"),
  },

  {
    path: "/ranking",
    name: "ranking",
    component: () => import("../views/ranking/index.vue"),
  },
  {
    path: "/guessList",
    name: "guessList",
    component: () => import("../views/ranking/guessList.vue"),
  },
  {
    path: "/certificate1",
    name: "certificate1",
    component: () => import("../views/certificate/certificate1.vue"),
  },
  {
    path: "/certificate2",
    name: "certificate2",
    component: () => import("../views/certificate/certificate2.vue"),
  },
  {
    path: "/lottery",
    name: "lottery",
    component: () => import("../views/lottery/index.vue"),
  },
  {
    path: "/mall",
    name: "mall",
    component: () => import("../views/mall/index.vue"),
  },
  {
    path: "*",
    redirect: "/home",
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

// router.beforeEach((to, from, next) => {
//   // 判断该路由是否需要登录权限
//   if (to.meta.type === "login") {
//     if (localStorage.getItem("userInfo")) {
//       next();
//     } else {
//       next();
//       store.commit("toggleLogin");
//     }
//   next()
// })

//静态资源替换后，刷新页面
router.onError((error) => {
  const jsPattern = /Loading chunk (\S)+ failed/g;
  const cssPattern = /Loading CSS chunk (\S)+ failed/g;
  const isChunkLoadFailed = error.message.match(jsPattern || cssPattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    localStorage.setItem("targetPath", targetPath);
    window.location.reload();
  }
});
//刷新后调整新页面
router.onReady(() => {
  const targetPath = localStorage.getItem("targetPath");
  const tryReload = localStorage.getItem("tryReload");
  if (targetPath) {
    localStorage.removeItem("targetPath");
    if (!tryReload) {
      router.replace(targetPath);
      localStorage.setItem("tryReload", true);
    } else {
      localStorage.removeItem("tryReload");
    }
  }
});

export default router;
